import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Agent, AgentClient, AgentService, AgentServicesClient, BankDetails, DeliverService, DeliverServicesClient, NServices, ServiceClient } from "src/app/web-api-client";

@Component({
  selector: 'app-agentService-creation',
  templateUrl: './agentService-creation.component.html',
  styleUrls: ['./agentService-creation.component.scss']
})
export class AgentServiceCreationComponent implements OnInit {

  public isLoaded = false;
  public agentId: number;
  public services: NServices[];
  public onClose = new Subject();
  public selectedAccount:BankDetails;

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: AgentServicesClient, public serviceClient: ServiceClient) { }

  ngOnInit(): void {

    this.serviceClient.getList().subscribe(services => {

      this.services = services;
      this.initializeForm();
      this.isLoaded = true;

    })

  }

  initializeForm() {
    this.Form = this.fb.group({
       title: ['', Validators.required],
      agentCommission: ['', Validators.required],
      service: ['', Validators.required],
      isActive: [null, Validators.required]
    });
  }

  onSubmit() {
    if (this.Form.valid && this.selectedAccount) {

      let service = new AgentService();

      service.idAgentsService = 0;
      service.title = this.Form.value.title;
      service.agentCommission = this.Form.value.agentCommission;
      service.idBankDetails = this.selectedAccount.idBankDetails;
      service.isActive = this.Form.value.isActive;
      service.idService = this.Form.value.service;
      service.idAgent = this.agentId;

      this.client.create(service).subscribe((user) => {

        this.onClose.next('');
        this.activeModal.close();
      });
    }
  }

  onBankAccountSelected(bankAccount:BankDetails) {
    this.selectedAccount = bankAccount;
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

}
